module.exports = __webpack_public_path__ + "static/media/atu-lsa.6beccec0.jpg";